<template>
  <div class="page">
    <h1>预览</h1>
    <custom-widget v-for="(item,index) in items" :key="index" :item="item"></custom-widget>
    <van-button type="primary">默认按钮</van-button>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "vant";

Vue.use(Button);

export default {
  name: "preview",
  data() {
    return {
      items: [{
          type: 300,
          data: {
            type: 1,
            text: "导航(4 - 标题)"
          }
        },
        {
          type: 100,
          data: {
            count: 4,
            showTitle: true,
            textColor: "#333333",
            items: [
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: "https://www.baidu.com"
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: "http://www.baidu.com"
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: "http://localhost:8080/test"
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              }
            ]
          }
        },
        {
          type: 300,
          data: {
            type: 1,
            text: "导航(4 - 无标题)"
          }
        },
        {
          type: 100,
          data: {
            count: 4,
            showIcon: true,
            showTitle: false,
            textColor: "#333333",
            items: [
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              }
            ]
          }
        },
        {
          type: 300,
          data: {
            type: 1,
            text: "导航(3 - 标题)"
          }
        },
        {
          type: 100,
          data: {
            count: 3,
            showIcon: true,
            showTitle: true,
            textColor: "#333333",
            items: [
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              }
            ]
          }
        },
        {
          type: 300,
          data: {
            type: 1,
            text: "导航(5 - 标题)"
          }
        },
        {
          type: 100,
          data: {
            count: 5,
            showIcon: true,
            showTitle: true,
            textColor: "#333333",
            items: [
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              },
              {
                icon:
                  "https://i.52112.com/icon/jpg/256/20191216/69442/2975512.jpg",
                title: "智慧购",
                url: ""
              }
            ]
          }
        },
        {
          type: 300,
          data: {
            type: 2,
            image: "http://www.akuziti.com/cache/157838693122399.png",
            showMore: true,
            url: "/home",
            start: 1578385873112,
            end: 1578395104275
          }
        },
        {
          type: 500,
          data: {
            type: 4,
            items:[
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                {
                  image: 'https://img.yzcdn.cn/vant/apple-2.jpg',
                  title: '测试',
                  to: '/test'
                }],
                round: true,
                shadow: true,
          }
        },
        {
          type: 500,
          data: {
            type: 1,
            items:[
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                }],
                round: true,
                shadow: true,
          }
        },
        {
          type: 500,
          data: {
            type: 2,
            items:[
              {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                }],
                round: true,
                shadow: true,
          }
        },
        {
          type: 500,
          data: {
            type: 3,
            items:[
              {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                }],
                round: true,
                shadow: true,
          }
        },
        {
          type: 500,
          data: {
            type: 5,
            items:[
              {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                }],
                round: true,
                shadow: true,
          }
        },
        {
          type: 501,
          data: {
            type: 5,
            item:
               {
                  image: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                  title: '测试',
                  to: '/test'
                },
                round: true,
                shadow: true,
          }
        },
      ],
    };
  },
  mounted() {
    var req = new XMLHttpRequest();
    req.open("GET", document.location, false);
    //req.send(null);
    console.log(req.getAllResponseHeaders());
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
